export enum WoonmilieuAbf13Enum {
  CENTRUM = 'Centrum',
  STEDELIJK_COMPACT = 'Stedelijk Compact',
  STEDELIJK_GRONDGEBONDEN = 'Stedelijk Grondgebonden',
  STEDELIJK_MET_GROEN = 'Stedelijk met Groen',
  LANDELIJK_OF_DORPS = 'Landelijk of Dorps bij de stad',
  DORPS = 'Dorps',
  LANDELIJK = 'Landelijk',
  GEEN_WOONMILIEU = 'Geen Woonmilieu',
}
